import { useMatrixWhatsappSettings } from '@/core/domain/enterprise/MatrixWhatsappSettings/MatrixWhatsappSettings.hooks';
import { MatrixWhatsappSettings } from '@/core/domain/enterprise/MatrixWhatsappSettings/MatrixWhatsappSettings.types';
import { Select, SelectProps } from 'antd';
import { DefaultOptionType } from 'antd/lib/select';
import React from 'react';

interface Props extends SelectProps {
  onTemplateSelect: (obj?: MatrixWhatsappSettings) => void;
}

const WhatsappTemplatesSelectField: React.FC<Props> = ({
  onTemplateSelect,
  ...props
}) => {
  const { data, isFetching } = useMatrixWhatsappSettings();

  const handleChanged = (
    value: number,
    option: DefaultOptionType | DefaultOptionType[],
  ) => {
    if (onTemplateSelect && data?.length) {
      onTemplateSelect(data?.find((item) => item.id === value));

      !!props.onChange && props.onChange(value, option);
    }
  };

  return (
    <Select
      {...props}
      allowClear
      loading={isFetching}
      options={data?.map((item) => ({
        value: item.id,
        label: item.title,
      }))}
      onChange={handleChanged}
    />
  );
};

export default WhatsappTemplatesSelectField;
